import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { Button } from './ui/button';

const Hero = () => {
  const scrollToContact = () => {
    const element = document.querySelector('#contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section
      id="hero"
      data-testid="hero-section"
      className="relative min-h-screen flex items-center justify-center overflow-hidden"
    >
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://images.unsplash.com/photo-1769326541255-c6612ab334a0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODd8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBtb2Rlcm4lMjBraXRjaGVuJTIwcmVub3ZhdGlvbiUyMHdoaXRlJTIwZ29sZCUyMG1hcmJsZXxlbnwwfHx8fDE3NzI3ODI4MDV8MA&ixlib=rb-4.1.0&q=85"
          alt="Luxury modern kitchen renovation"
          className="w-full h-full object-cover"
        />
        {/* Dark Overlay */}
        <div className="absolute inset-0 bg-black/50" />
      </div>

      {/* Content */}
      <div className="relative z-10 container-custom px-6 text-center">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="max-w-4xl mx-auto"
        >
          {/* Tagline */}
          <motion.p
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.2, duration: 0.6 }}
            className="text-[#D4AF37] text-sm md:text-base font-medium tracking-[0.3em] uppercase mb-6"
          >
            Premium Home Renovations
          </motion.p>

          {/* Headline */}
          <motion.h1
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.3, duration: 0.8 }}
            data-testid="hero-headline"
            className="font-serif text-4xl sm:text-5xl lg:text-6xl xl:text-7xl text-white font-bold leading-tight mb-6"
          >
            Transform Your Home
            <br />
            <span className="text-[#D4AF37]">with Expert Renovations</span>
          </motion.h1>

          {/* Subheadline */}
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.5, duration: 0.8 }}
            data-testid="hero-subheadline"
            className="text-white/90 text-base md:text-lg lg:text-xl max-w-2xl mx-auto mb-10 font-light leading-relaxed"
          >
            Lux Renovations provides high-quality kitchen, bathroom, and full home
            remodeling services for homeowners in Gaithersburg and surrounding
            Maryland areas.
          </motion.p>

          {/* CTA Buttons */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.7, duration: 0.8 }}
            className="flex flex-col sm:flex-row gap-4 justify-center items-center"
          >
            <Button
              onClick={scrollToContact}
              data-testid="hero-cta-primary"
              className="bg-[#D4AF37] text-[#0A0A0A] hover:bg-[#C9A227] rounded-none px-8 py-6 text-base font-medium tracking-wide flex items-center gap-2 group"
            >
              Get a Free Consultation
              <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
            </Button>
            <Button
              onClick={() => {
                const element = document.querySelector('#gallery');
                if (element) element.scrollIntoView({ behavior: 'smooth' });
              }}
              data-testid="hero-cta-secondary"
              variant="outline"
              className="border-2 border-white text-white hover:bg-white hover:text-[#0A0A0A] rounded-none px-8 py-6 text-base font-medium tracking-wide bg-transparent"
            >
              View Our Work
            </Button>
          </motion.div>
        </motion.div>

        {/* Scroll Indicator */}
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 1.2, duration: 0.8 }}
          className="absolute bottom-8 left-1/2 -translate-x-1/2"
        >
          <div className="flex flex-col items-center gap-2 text-white/60">
            <span className="text-xs tracking-widest uppercase">Scroll</span>
            <div className="w-px h-12 bg-gradient-to-b from-white/60 to-transparent" />
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Hero;
